import { Flex, Text } from "@/atoms"
import { HealthWarning } from "@/pages/IntegrationsPage/components/molecules/HealthWarning"

import styles from "./ConfigItem.module.scss"

import type { LabelConfigItemProps } from "."

export const LabelConfigItem = (props: LabelConfigItemProps) => {
  const { values, Description } = props
  const description = Description || values.description
  const { health } = values

  return (
    <Flex vertical>
      <Flex gap={8} align="center">
        <Text strong>{values.name}</Text>
        <HealthWarning health={health} className={styles.healthIcon} />
      </Flex>
      {description && (
        <Text type="secondary">
          <Flex gap={4} className={styles.labelConfigItem__description}>
            <Text type="secondary">{Description || description}</Text>
          </Flex>
        </Text>
      )}
    </Flex>
  )
}
